import React, { useContext, useState, useEffect } from "react";
import parse from "react-html-parser";
import MppInfo from "./MppModalInfo";
import Accordion from "react-bootstrap/Accordion";
import PriceInput from "./PriceInput";
import Spinner from "../MPPSpinner";
import { Row, Button, Col, Container } from "react-bootstrap";
import { ThemeContext } from "../../container/mppmodal/MppInfo";
import configuration from "../../configuration/configuration";
import Tooltip from "react-tooltip-lite";
import toolTipIcon from "../../assets/images/toolTipIcon.svg";
import services from "../../services/Services";
import { getSyfQuickScreenDecline, getUpdatedFlow } from "../../container/mppmodal/Utils";


const MppModalBody = (props) => {
  const {
    offersType: { isApplyOffer, isSetPayOffer },
  } = props;

  const {
    flowType,
    queryValues,
    isSpinnerDisplayed,
    showMsfFlag,
    totalAmount,
    offerDisclaimer,
    offerStaticLanguage,
    offerRangeLanguage,
    tooltipDisclosure,
    offers,
    brandings: {
      mppPrimaryColors,
      preQual,
      availableOffersText,
      shopAvailableOffersText,
      prequalifyButtonText,
      prequalifyButtonTextMultiProduct,
      applyButtonText,
      creditCardImage
    },
    brandings,
    openApplyHandler,
    openSetPayIn4,
    merchantName,
    syfToken,
    setPayIn4Info,
    partnerId,
    merchantNumber,
    getDevice,
    continueCallback,
    showMppAmountInputBox,
    subtitlempp,
    isMerchantApiFailed,
    queryValues: { d2dFlow },
    empqFlag,
    mppFromEmail,
    openPayLater,
    empqPaylaterMonthlyFlag,
    additionalInfo,
    softapplyEnabled,
    subtitleNoteSoftapplympp,
    orgPlatForm,
    clientName,
    mppConfig,
    offersDetails: { quickScreenInfo },
    qsDeclineScreenPayload,
    quickScreenUserActivity,
    orgFlow,
    payInFourProductConfigured,
    adobe_mcvid
  } = useContext(ThemeContext);

  const { applyButtonquickScreen, declineButtonquickScreen, quickScreenApproved, startNewApplicationLinkquickScreen, subHeaderquickScreen } = mppConfig || {};
  const [offersDisplay, setOffersDisplay] = useState(true);
  const [active, setActive] = useState(null);
  const [activeIndex, setActiveIndex] = useState("");
  const prequalButtonTextToDisplay = payInFourProductConfigured
    ? prequalifyButtonTextMultiProduct
    : prequalifyButtonText;

  const [action, setAction] = useState(null);
  const [actionIndex, setActionIndex] = useState("");


  useEffect(() => {
    if (quickScreenApproved) setWindowHeight();
  })

  useEffect(() => {
    window.addEventListener("message", (event) => {
      if (event.data === 'qs_decline') qsCloseBtnClick();
    });
  }, [])

  if (offers === "") return;

  const nonSetPayOffer = offers?.filter(
    (offerDetails) =>
      offerDetails.preferredOffer === "YES" &&
      !["SetPAYIn4", "SetPAY"].includes(offerDetails.offerType)
  );

  const setPayIn4ToolTip = offers?.filter(
    (offerDetails) =>
      ["SetPAYIn4"].includes(offerDetails.offerType)
  );


  const installmentOffer = offers?.filter(
    (offerDetails) =>
      offerDetails.preferredOffer === "YES" &&
      ["SetPAY"].includes(offerDetails.offerType)
  );

  let isSetPayIn4Alone = false;

  if (nonSetPayOffer.length === 0) {
    const featuredOffer = offers?.filter(
      (offerDetails) => offerDetails.preferredOffer === "YES"
    );
    isSetPayIn4Alone =
      featuredOffer.length === 1 && featuredOffer[0].offerType === "SetPAYIn4";
  }

  const revolvingOffer = Object.entries(offers).map((applyOfferDetails) => {
    const offers = applyOfferDetails
      .filter((offerDetails) => offerDetails.preferredOffer == "YES")
      .map((offerDetails, index) => {
        return {
          monthlyPaymentDisclosure: offerDetails.monthlyPaymentDisclosure,
          ofpLanguage: offerDetails.ofpLanguage,
          monthlyPaymentDisclosureLanguage:
            offerDetails.monthlyPaymentDisclosureLanguage,
          offerDisclosure: offerDetails.offerDisclosure,
          prefferedOffer: offerDetails.preferredOffer,
          ofpTitle: offerDetails.offerTitle,
          amount: offerDetails.calculatedAmount,
          discountEligible: offerDetails.discountEligible,
          offerBannerDisclaimer: offerDetails.offerBannerDisclaimer,
          offerBannerTitle: offerDetails.offerBannerTitle,
          offerLoyaltyPromoDisclosure: offerDetails.loyaltyPromoDisclosure,
          index: offerCount,
          durationInMonth: offerDetails.durationInMonths,
          offerBannerSubTitle: offerDetails.offerBannerSubTitle,
          offerDisclosureLanguage: offerDetails.offerDisclosureLanguage,
          offerType: offerDetails.offerType,
          totalPayment: offerDetails.totalPayment,
          delayMinimumPayment: offerDetails.delayMinimumPayment,
          paymentDelayInMonths: offerDetails.paymentDelayInMonths,
          minimumMonthPaymentFlag: offerDetails.minimumMonthlyPaymentFlag,
          limitedTimeOfferDateFormat: offerDetails.limitedTimeOfferDateFormat,
          monthlyPaymentDisclosureLanguageDisclaimer: offerDetails.monthlyPaymentDisclosureLanguageDisclaimer,
          offerDisclosureDisclaimer: offerDetails.offerDisclosureDisclaimer
        };
      });

    return offers;
  })[0][0];

  const isWPDAAtFirst =
    Object.entries(offers).filter((offerDesc, index) => {
      const wpdiOfferType = offers[0].offerType;
      return index === 0 && wpdiOfferType === "WPDI";
    }).length > 0;
  var offerCount = -1;
  const PopulateOffers = () => {
    const callback = (id) => {
      setActive(id);
    };

    let count = -1;
    let prevOfferType = "";
    const prefferdOffers = offers.filter(
      (offerDetails) => offerDetails.preferredOffer == "YES"
    );
    return Object.entries(offers).map((applyOfferDetails, mainIndex) => {
      const domOffers = applyOfferDetails
        .filter((offerDetails) => offerDetails.preferredOffer == "YES")
        .map((offerDetails, index) => {
          count = count + 1;
          offerCount = offerCount + 1;
          if (count != 0)
            prevOfferType =
              prefferdOffers[count - 1].offerType != "SetPAY"
                ? "Revolving"
                : "SetPAY";

          return offerDetails.offerType === "SetPAYIn4" &&
            flowType === "CHECKOUT" ? (
            <></>
          ) : (
            <MppInfo
              flowType={flowType}
              isCheckoutLearnClicked={queryValues?.isCheckoutLearnClicked}
              merchantNumber={merchantNumber}
              key={offerDetails.offerTitle}
              mainIndex={mainIndex}
              openApplyHandler={openApplyHandler}
              openSetPayIn4={openSetPayIn4}
              ofpTitle={offerDetails.offerTitle}
              amount={offerDetails.calculatedAmount}
              apr={offerDetails.apr}
              minimumMonthPaymentFlag={offerDetails.minimumMonthlyPaymentFlag}
              totalPayment={offerDetails.totalPayment}
              discountEligible={offerDetails.discountEligible}
              offerBannerTitle={offerDetails.offerBannerTitle}
              offerLoyaltyPromoDisclosure={offerDetails.loyaltyPromoDisclosure}
              durationInMonth={offerDetails.durationInMonths}
              offerBannerDisclaimer={offerDetails.offerBannerDisclaimer}
              offerBannerSubTitle={offerDetails.offerBannerSubTitle}
              offerType={offerDetails.offerType}
              ofpLanguage={offerDetails.ofpLanguage}
              monthlyPaymentDisclosure={offerDetails.monthlyPaymentDisclosure}
              monthlyPaymentDisclosureLanguage={
                offerDetails.monthlyPaymentDisclosureLanguage
              }
              monthlyPaymentDisclosureLanguageDisclaimer={offerDetails.monthlyPaymentDisclosureLanguageDisclaimer}
              offerDisclosureDisclaimer={offerDetails.offerDisclosureDisclaimer}
              offerDisclosure={offerDetails.offerDisclosure}
              offerNumber={offerDetails.offerNumber}
              offerStaticLanguage={offerDetails.offerStaticLanguage}
              offerRangeLanguage={offerDetails.offerRangeLanguage}
              tooltipDisclosure={offerDetails.tooltipDisclosure}
              prefferedOffer={offerDetails.preferredOffer}
              maxPurchase={offerDetails.maxPurchase}
              minPurchase={offerDetails.minPurchase}
              delayMinimumPayment={offerDetails.delayMinimumPayment}
              paymentDelayInMonths={offerDetails.paymentDelayInMonths}
              limitedTimeOfferDateFormat={
                offerDetails.limitedTimeOfferDateFormat
              }
              limitedTimeOfferDateFormatVariant={
                offerDetails.limitedTimeOfferDateFormatVariant
              }
              isWPDAAtFirst={isWPDAAtFirst}
              offerDisclosureLanguage={offerDetails.offerDisclosureLanguage}
              index={offerCount}
              accordianIndex={count}
              brandings={brandings}
              toggleProp={active}
              syfToken={syfToken}
              callback={callback}
              merchantName={merchantName}
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
              displayLabel={
                prevOfferType == ""
                  ? true
                  : (offerDetails.offerType != "SetPAY"
                    ? "Revolving"
                    : "SetPAY") == prevOfferType
                    ? false
                    : true
              }
              partnerId={partnerId}
            />
          );
        });

      return domOffers;
    });
  };

  const PopulateOffersInCheckoutFlow = () => {
    return offers
      .filter(
        (offerDetails) =>
          offerDetails.preferredOffer === "YES" &&
          offerDetails.offerType === "SetPAYIn4"
      )
      .map((featuredOffers) => {
        return (
          <MppInfo
            flowType="CHECKOUT"
            isCheckoutLearnClicked={queryValues?.isCheckoutLearnClicked}
            merchantNumber={merchantNumber}
            setPayIn4Info={featuredOffers.setPayIn4Info.terms}
            key={featuredOffers.offerTitle}
            brandings={brandings}
            openApplyHandler={openApplyHandler}
            openSetPayIn4={openSetPayIn4}
            ofpTitle={featuredOffers.offerTitle}
            amount={featuredOffers.calculatedAmount}
            apr={featuredOffers.apr}
            index={offerCount}
            minimumMonthPaymentFlag={featuredOffers.minimumMonthlyPaymentFlag}
            offerType={featuredOffers.offerType}
            prefferedOffer={featuredOffers.preferredOffer}
            offerBannerDisclaimer={featuredOffers.offerBannerDisclaimer}
            offerBannerSubTitle={featuredOffers.offerBannerSubTitle}
            discountEligible={featuredOffers.discountEligible}
            offerBannerTitle={featuredOffers.offerBannerTitle}
            offerLoyaltyPromoDisclosure={featuredOffers.loyaltyPromoDisclosure}
            limitedTimeOfferDateFormat={
              featuredOffers.limitedTimeOfferDateFormat
            }
            limitedTimeOfferDateFormatVariant={
              featuredOffers.limitedTimeOfferDateFormatVariant
            }
            offerDisclosureLanguage={featuredOffers.offerDisclosureLanguage}
            offerDisclosure={featuredOffers.offerDisclosure}
            monthlyPaymentDisclosure={featuredOffers.monthlyPaymentDisclosure}
            monthlyPaymentDisclosureLanguage={featuredOffers.monthlyPaymentDisclosureLanguage}
            monthlyPaymentDisclosureLanguageDisclaimer={featuredOffers.monthlyPaymentDisclosureLanguageDisclaimer}
            maxPurchase={featuredOffers.maxPurchase}
            minPurchase={featuredOffers.minPurchase}
            accordianIndex={offers.length == 1 ? 0 : -1}
          />
        );
      });
  };

  //setpay offers

  const SetPayOffers = () => {
    const callback = (id) => {
      setAction(id);
    };

    let count2 = -1;
    let prevOfferType = "";
    const otherOffers = offers.filter(
      (offerDetails) => offerDetails.preferredOffer == "NO"
    );

    return Object.entries(offers).map((setPayOfferDetails, mainIndex) => {
      const setPayOffers = setPayOfferDetails
        .filter((offerDetails) => offerDetails.preferredOffer == "NO")
        .map((offerDetails) => {
          count2 = count2 + 1;
          offerCount = offerCount + 1;
          if (count2 != 0)
            prevOfferType =
              otherOffers[count2 - 1].offerType != "SetPAY"
                ? "Revolving"
                : "SetPAY";
          return (
            <MppInfo
              flowType={flowType}
              isCheckoutLearnClicked={queryValues?.isCheckoutLearnClicked}
              key={offerDetails.offerTitle}
              merchantNumber={merchantNumber}
              mainIndex={mainIndex}
              openApplyHandler={openApplyHandler}
              openSetPayIn4={openSetPayIn4}
              ofpTitle={offerDetails.offerTitle}
              amount={offerDetails.calculatedAmount}
              apr={offerDetails.apr}
              minimumMonthPaymentFlag={offerDetails.minimumMonthlyPaymentFlag}
              totalPayment={offerDetails.totalPayment}
              durationInMonth={offerDetails.durationInMonths}
              offerType={offerDetails.offerType}
              discountEligible={offerDetails.discountEligible}
              offerBannerTitle={offerDetails.offerBannerTitle}
              offerLoyaltyPromoDisclosure={offerDetails.loyaltyPromoDisclosure}
              offerBannerDisclaimer={offerDetails.offerBannerDisclaimer}
              offerBannerSubTitle={offerDetails.offerBannerSubTitle}
              ofpLanguage={offerDetails.ofpLanguage}
              monthlyPaymentDisclosure={offerDetails.monthlyPaymentDisclosure}
              monthlyPaymentDisclosureLanguage={
                offerDetails.monthlyPaymentDisclosureLanguage
              }
              monthlyPaymentDisclosureLanguageDisclaimer={offerDetails.monthlyPaymentDisclosureLanguageDisclaimer}
              offerDisclosureDisclaimer={offerDetails.offerDisclosureDisclaimer}
              maxPurchase={offerDetails.maxPurchase}
              minPurchase={offerDetails.minPurchase}
              offerDisclosure={offerDetails.offerDisclosure}
              offerNumber={offerDetails.offerNumber}
              offerStaticLanguage={offerDetails.offerStaticLanguage}
              offerRangeLanguage={offerDetails.offerRangeLanguage}
              tooltipDisclosure={offerDetails.tooltipDisclosure}
              isWPDAAtFirst={isWPDAAtFirst}
              offerDisclosureLanguage={offerDetails.offerDisclosureLanguage}
              paymentDelayInMonths={offerDetails.paymentDelayInMonths}
              delayMinimumPayment={offerDetails.delayMinimumPayment}
              limitedTimeOfferDateFormat={
                offerDetails.limitedTimeOfferDateFormat
              }
              limitedTimeOfferDateFormatVariant={
                offerDetails.limitedTimeOfferDateFormatVariant
              }
              prefferedOffer={offerDetails.preferredOffer}
              index={offerCount}
              accordianIndex={count2}
              brandings={brandings}
              toggleProp={action}
              syfToken={syfToken}
              callback={callback}
              merchantName={merchantName}
              activeIndex={actionIndex}
              setActiveIndex={setActionIndex}
              displayLabel={
                prevOfferType == ""
                  ? true
                  : (offerDetails.offerType != "SetPAY"
                    ? "Revolving"
                    : "SetPAY") == prevOfferType
                    ? false
                    : true
              }
              partnerId={partnerId}
            />
          );
        });
      return setPayOffers;
    });
  };

  const continueMsfCheckout = () => {
    let url = configuration[window._syfMpp_.SYF_MPP_ENV].msfCheckout + '?flowOrigin=Checkout-MPP-Fortiva';
    const form = document.createElement("form");
    form.method = "POST";
    form.action = url;

    const requestParams = { ...queryValues, ...additionalInfo, softapplyEnabled, clientName: clientName || merchantName }
      Object.keys(requestParams).forEach((key) => {

      if (key === "flowType") {
        const hiddenField = document.createElement("input");
        hiddenField.type = "hidden";
        hiddenField.name = key;
        hiddenField.value = "MPPCONTINUECHECKOUT";
        form.appendChild(hiddenField);
      }

      if (
        [
          "passedJson",
          "syfPartnerId",
          "processInd",
          "childSyfMerchantNumber",
          "adobe_mc",
          "preQual",
          "prequalStatus",
          "productCategoryNames",
          "productCategoryNames1",
          "productCategoryNames2",
          "productCategoryNames3",
          "syfToken",
          "tokenId",
          "transactionToken",
          "transAmount1",
          "transAmount2",
          "transAmount3",
          "postbackid",
          "envUrl",
          "partnerId",
          "encryptKey",
          "modalType",
          "childPcgc",
          "childTransType",
          "pcgc",
          "partnerCode",
          "clientToken",
          "clientTransId",
          "cardNumber",
          "custFirstName",
          "custLastName",
          "expMonth",
          "expYear",
          "custZipCode",
          "custAddress1",
          "custAddress2",
          "phoneNumb",
          "appartment",
          "emailAddr",
          "custCity",
          "upeProgramName",
          "custState",
          "transPromo1",
          "transPromo2",
          "transPromo3",
          "iniPurAmt",
          "mid",
          "promotionalTags",
          "promotionalTags1",
          "promotionalTags2",
          "promotionalTags3",
          "offerNumber1",
          "offerNumber2",
          "offerNumber3",
          "description1",
          "description2",
          "description3",
          "initialAmount",
          "merchantDomainURL",
          "d2dFlow",
          "childSyfPartnerId",
          "partnerCode",
          "childSyfMerchantNumber",
          "saveCard",
          "showConsent",
          "DBuy",
          "promoOverRideFlag",
          "isEcartPromoOverRideAvailable",
          "storeMid",
          "softapplyEnabled",
          "merchantRefererUrl",
          "partnerProfileCode",
          "siteCode",
          "clientTransId",
          "clientName",
          "browserFriendlyPaymentToken",
          "editAmountOnConsumerOffer",
          "transactionType",
          "editAmountOnConsumerOffer",
          "transactionType",
          "acquisitionFlag"
        ].includes(key)
      ) {
        const hiddenField = document.createElement("input");
         hiddenField.type = "hidden";
        hiddenField.name = key;
        hiddenField.value = requestParams[key];
        form.appendChild(hiddenField);
      }
    });

    document.body.appendChild(form);
    form.submit();
    continueCallback();
  };

  const handleCheckout = () => {
    //call to dbuy 2.0
    ContinueCheckout('payLater');
    //openPayLater() dbuy 1.0
    
  }

  const ContinueCheckout = (product) => {
    let url = configuration[window._syfMpp_.SYF_MPP_ENV].mppCheckout;
    const form = document.createElement("form");
    form.method = "POST";
    form.action = url;

    const requestParams = { ...queryValues, ...additionalInfo, softapplyEnabled, clientName: clientName || merchantName, orgFlow: orgFlow === "Checkout-Stripe-MPP-dBuy" ? orgFlow : getUpdatedFlow(orgFlow, "dBuy"), adobe_mcvid}
    const fetchMultiBuckets = { ...queryValues }
    
    if(adobe_mcvid){
      url = url + "?adobe_mcvid=" + encodeURIComponent(adobe_mcvid);
    }

    if (product === 'payLater' && nonSetPayOffer.length === 0) {
      console.log("added paylater only.....")
      const hiddenField = document.createElement("input");
      hiddenField.type = "hidden";
      hiddenField.name = "payLaterOnly";
      hiddenField.value = 'Y';
      form.appendChild(hiddenField);
    }
    Object.keys(requestParams).forEach((key) => {

      if (key === "flowType") {
        const hiddenField = document.createElement("input");
        hiddenField.type = "hidden";
        hiddenField.name = key;
        hiddenField.value = "MPPCONTINUECHECKOUT";
        form.appendChild(hiddenField);
      }

      if (
        [
          "passedJson",
          "syfPartnerId",
          "processInd",
          "childSyfMerchantNumber",
          "adobe_mc",
          "preQual",
          "prequalStatus",
          "productCategoryNames",
          "productCategoryNames1",
          "productCategoryNames2",
          "productCategoryNames3",
          "syfToken",
          "tokenId",
          "transactionToken",
          "transAmount1",
          "transAmount2",
          "transAmount3",
          "postbackid",
          "envUrl",
          "partnerId",
          "encryptKey",
          "modalType",
          "childPcgc",
          "childTransType",
          "pcgc",
          "partnerCode",
          "clientToken",
          "clientTransId",
          "cardNumber",
          "custFirstName",
          "custLastName",
          "expMonth",
          "expYear",
          "custZipCode",
          "custAddress1",
          "custAddress2",
          "phoneNumb",
          "appartment",
          "emailAddr",
          "custCity",
          "upeProgramName",
          "custState",
          "transPromo1",
          "transPromo2",
          "transPromo3",
          "iniPurAmt",
          "mid",
          "promotionalTags",
          "promotionalTags1",
          "promotionalTags2",
          "promotionalTags3",
          "offerNumber1",
          "offerNumber2",
          "offerNumber3",
          "description1",
          "description2",
          "description3",
          "initialAmount",
          "merchantDomainURL",
          "d2dFlow",
          "childSyfPartnerId",
          "partnerCode",
          "childSyfMerchantNumber",
          "saveCard",
          "showConsent",
          "DBuy",
          "promoOverRideFlag",
          "isEcartPromoOverRideAvailable",
          "storeMid",
          "softapplyEnabled",
          "merchantRefererUrl",
          "partnerProfileCode",
          "siteCode",
          "clientTransId",
          "clientName",
          "browserFriendlyPaymentToken",
          "editAmountOnConsumerOffer",
          "transactionType",
          "editAmountOnConsumerOffer",
          "transactionType",
          "DBuy",
          "acquisitionFlag",
          "additionalFormInfo",
          "adobe_mcvid",
          "orgFlow",
          "dataShareToken",
          "isPayInFourProductAvailable",
          "productIds1",
          "productIds2",
          "productIds3"
        ].includes(key)
      ) {
        const hiddenField = document.createElement("input");
        hiddenField.type = "hidden";
        hiddenField.name = key;
        hiddenField.value = requestParams[key];
        form.appendChild(hiddenField);
      }
    });

    if (fetchMultiBuckets['d2dFlow'] != 'undefined' && fetchMultiBuckets['d2dFlow'] === 'Y') {
      if (!(fetchMultiBuckets['transAmount1'] === undefined || fetchMultiBuckets['transAmount1'] === null)) {
        form['transAmount1'].value = fetchMultiBuckets['transAmount1'];
      }
      if (!(fetchMultiBuckets['transAmount2'] === undefined || fetchMultiBuckets['transAmount2'] === null)) {
        form['transAmount2'].value = fetchMultiBuckets['transAmount2'];
      }
      if (!(fetchMultiBuckets['transAmount3'] === undefined || fetchMultiBuckets['transAmount3'] === null)) {
        form['transAmount3'].value = fetchMultiBuckets['transAmount3'];
      }
    }

    if (setPayIn4Info) {
      const hiddenField = document.createElement("input");
      hiddenField.type = "hidden";
      hiddenField.name = "setPayIn4Info";
      hiddenField.value = JSON.stringify(setPayIn4Info);
      form.appendChild(hiddenField);
    }




    if (empqFlag) {
      const hiddenField = document.createElement("input");
      hiddenField.type = "hidden";
      hiddenField.name = "empqFlag";
      hiddenField.value = empqFlag;
      form.appendChild(hiddenField);

      const applyHiddenField = document.createElement("input");
      applyHiddenField.type = "hidden";
      applyHiddenField.name = "modalapply";
      applyHiddenField.value = true;
      form.appendChild(applyHiddenField);
    }

    document.body.appendChild(form);
    form.submit();
    continueCallback();
    analyticsChangesForContinueCheckout(
      merchantName,
      merchantNumber,
      syfToken,
      partnerId,
      orgPlatForm
    );
  };
  function analyticsChangesForContinueCheckout(
    merchantName,
    merchantNumber,
    syfToken,
    partnerId,
    orgPlatForm
  ) {
    const pageInfo = window._syf_?._mppOffer_?._SFDDL?.pageInfo || {};
    window._syf_._mppOffer_._SFDDL.pageInfo = {
      ...pageInfo,
      Country_Language: "US|ENG",
      SiteIdentifier: "digitalpos",
      CustomerType: "consumer",
      ClientName: merchantName,
      PageFunction: "Continue Checkout",
      PageName: "continue checkout",
      Device: getDevice,
      PNL: "PS",
      MerchantID: merchantNumber,
      PageKind: "merchant",
      Placements: flowType,
      OfferCount: "",
      TargetName: "",
      TokenId: syfToken,
      Message: "MPP Page Learn How",
      SyfPartnerID: partnerId,
      orgFlow: orgFlow === "Checkout-Stripe-MPP-dBuy" ? "Checkout-Stripe-dBuy" : getUpdatedFlow(orgFlow, "dBuy"),
      orgPlatForm
    };

    window._syf_._mppOffer_._SFDDL.click = {
      action: "syfClickEvent",
      className: "syfClickEvent",
      "data-object": "button",
      "data-reason": "continue-checkout",
      "data-type": "body",
    };

    window._syf_._mppOffer_._SFDDL.formAction = {
      appType: "offers_mpp",
      product: "MPP",
      action: "offer_details_page",
    };

    var event = document.createEvent("Event");
    event = new CustomEvent("syfClickEvent");
    event.initEvent("syfClickEvent");
    dispatchEvent(event);
  }

  const setWindowHeight = () => {

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    window.innerWidth <= 540
      ? document.documentElement.style.setProperty("--mpp-model-body-height", `305px`)
      : document.documentElement.style.setProperty("--mpp-model-body-height", `321px`);

    window.addEventListener("resize", () => {
      document.documentElement.style.setProperty(
        "--screen-height",
        window.innerHeight + "px"
      );
      let resizevh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${resizevh}px`);

      window.innerWidth <= 540
        ? document.documentElement.style.setProperty("--mpp-model-body-height", `305px`)
        : document.documentElement.style.setProperty("--mpp-model-body-height", `321px`);

    });

  };

  //quickScreen close button function
  const qsCloseBtnClick = async () => {
    let syf_QS_Decline = getSyfQuickScreenDecline();
    quickScreenUserActivity.userAction = "DECLINE_OFFER";
    services.qsDecline(qsDeclineScreenPayload, quickScreenUserActivity)
      .catch((error) => {
        return error
      })
  }

  //quickScreen Ask Me Later functionality
  const qsSaveUserActivity = () => {
    quickScreenUserActivity.userAction = "ASK_ME_LATER";
    window.parent.postMessage({ _qsEventType: "ASK_ME_LATER" }, "*");
    services.saveQuickScreenUserActivity(quickScreenUserActivity, syfToken)
      .catch((error) => {
        return error
      })
    if (window && window.parent) {
      var parent = window.parent;
      parent.postMessage("Close", "*");
    }
  }

  //quickScreen Continue Btn functionality
  const openQsContinueHandler = () => {
    window._qsEventType = "VIEW_OFFER";
    openApplyHandler();
  }

  //quickScreen start new APplication Btn functionality
  const qsStartNewApplication = () => {
    window._qsEventType = "NOT_ME_APPLY";
    openApplyHandler();
  }

  const showMsfUI = () =>{
    console.log("starting msf checkout flow...");
    continueMsfCheckout();
  }

  return (
    <React.Fragment>
      <>
        <div className={mppFromEmail ? "email-modal-body" : "modal-body"} role="status" aria-live="polite" tabIndex="-1">
          <div>
            {(nonSetPayOffer.length > 0 || installmentOffer.length > 0) && flowType === "CHECKOUT" && (
              <div className="pl-15 pr-15">
                <Col xs="12" className="checkout-button">
                  <div className="have-card-flex">
                    {nonSetPayOffer.length > 0 && <div className="have-card-one" style={{ paddingRight: (installmentOffer.length > 0 && empqFlag === "Y") ? "34px" : "0px" }}>
                      <h1 className="have-cards have-card mb-0">
                        Checkout with your {clientName || merchantName} Card.
                      </h1>
                      <Button
                        className="btn btnPrimary btn-primary-continue-checkout  prequaliBtn"
                        tabIndex="0"
                        style={{
                          backgroundColor: mppPrimaryColors,
                          borderColor: mppPrimaryColors,
                        }}
                        onClick={()=>ContinueCheckout('revolving')}
                      >
                        CONTINUE TO CHECKOUT
                      </Button>
                    </div>}
                    {nonSetPayOffer.length > 0 && installmentOffer.length > 0 && empqFlag === "Y" && <div className="paddingTop16">
                      <hr className="ver-line" />
                    </div>}
                    {empqFlag === "Y" && installmentOffer.length > 0 &&
                      <div className="have-card-two" style={{ paddingLeft: nonSetPayOffer.length > 0 ? "34px" : "0px" }}>
                        <h1 className=" have-cards have-card mbtn ">
                          Already approved for Synchrony Pay Later Loan?
                        </h1>
                        <div>
                          <a className="application-status" data-type="mpp" data-object="link"
                            data-reason="check application status  " tabIndex="0"
                            onClick={handleCheckout} target="_blank" style={{ color: mppPrimaryColors }}>Check Application Status</a></div>
                      </div>
                    }
                  </div>
                </Col>
              </div>
            )}
          </div>
          {(flowType === "CHECKOUT" && (nonSetPayOffer.length > 0 || (empqFlag === "Y" && installmentOffer.length > 0))) && <hr className="hor-line" />}
          <div className="modal-offer-content">
            {
              <>
                <div>
                  <h1 className="bodayHeader mb-1">
                    <b>
                      {!["CHECKOUT"].includes(flowType)
                        ? shopAvailableOffersText || availableOffersText
                        : availableOffersText}
                      {!(["PDP", "MULTIWIDGET"].includes(flowType) && showMppAmountInputBox === "Y") && (
                        <> ${parseFloat(totalAmount).toFixed(2) || 0}</>
                      )}
                    </b>
                  </h1>
                  <div>
                    <p className= {quickScreenApproved && subHeaderquickScreen ? "availableSub-subHeading-available mt-0 ": "availableSub-heading mt-0 "}>{!isSetPayIn4Alone && subtitlempp}
                      {setPayIn4ToolTip.length > 0 && flowType === "PDP"  &&  !isSetPayIn4Alone && (
                        <Tooltip
                          className="syf_tooltipinfo tooltip-pdp"
                          content={tooltipDisclosure}
                          direction="down"
                          eventOn="onFocus"
                          eventOff="onKeyDown"
                        >
                          <img
                            src={toolTipIcon}
                            className="toolTipImg"
                            alt="Tool Tip"
                          ></img>
                        </Tooltip>)}
                    </p>
                    {quickScreenApproved && <p className="availableSub-heading mt-0 ">{subHeaderquickScreen || ''}</p>}
                  </div>
                  {["PDP", "MULTIWIDGET"].includes(flowType) && showMppAmountInputBox === "Y" && (
                    <>
                      <div className="mpp-any-where-label mb-1">
                        {quickScreenApproved ? <b>Purchase Amount</b> : <b>Enter Amount</b>}
                      </div>
                      <PriceInput setOffersDisplay={setOffersDisplay} />
                    </>
                  )}
                </div>
              </>
            }

            {isWPDAAtFirst && !isMerchantApiFailed && offersDisplay && (
              <Accordion defaultActiveKey="0" className={mppFromEmail ? "emailAccordion" : ""}>
                {isApplyOffer && <></>}
                {PopulateOffers()}

                {isSetPayOffer && <></>}

                <div>
                  {flowType !== "CHECKOUT" && SetPayOffers()}
                  {isSetPayOffer && (
                    <p
                      className="setPayInfotext text-center setPaycontent1"
                    >
                      {parse(offerRangeLanguage)}
                    </p>
                  )}

                  {isSetPayOffer && (
                    <p
                      className="setPayInfotext text-center setPaycontent2"
                    ></p>
                  )}

                  {isSetPayOffer && (
                    <p
                      className="setPayInfotext text-center setPaycontent3"
                    >
                      {offerStaticLanguage}
                    </p>
                  )}
                </div>
              </Accordion>
            )}

            {!isWPDAAtFirst && !isMerchantApiFailed && offersDisplay && (
              <Accordion className={mppFromEmail ? "emailAccordion" : ""}>
                {PopulateOffers()}
                <div>
                  {flowType !== "CHECKOUT" && SetPayOffers()}
                  {isSetPayOffer && (
                    <p
                      className="setPayInfotext text-center setPaycontent1"
                    >
                      {parse(offerRangeLanguage)}
                    </p>
                  )}
                  {isSetPayOffer && (
                    <p
                      className="setPayInfotext text-center setPaycontent2"
                    ></p>
                  )}
                  {isSetPayOffer && (
                    <p
                      className="setPayInfotext text-center setPaycontent3"
                    >
                      {offerStaticLanguage}
                    </p>
                  )}
                </div>
              </Accordion>
            )}

            {flowType === "CHECKOUT" && (
              <>
                {!isSetPayIn4Alone && (
                  <>
                    <div className="ml-0 p-0 onlyMediaScreen container-fluid">
                      <Row className="mb-2">
                        <Col xs="12">
                          <div className="text-center"><Button
                            className="btn btnPrimary modal-title checkoutFlowButtons syfClickEvent"
                            data-type="body" 
                            data-object="button"
								            data-reason= {preQual === "true"
                              ? prequalButtonTextToDisplay?.toLowerCase()
                              : applyButtonText?.toLowerCase()}
                            tabIndex="0"
                            onClick={openApplyHandler}
                            style={{
                              backgroundColor: mppPrimaryColors,
                              borderColor: mppPrimaryColors,
                            }}
                          >
                            {preQual === "true"
                              ? prequalButtonTextToDisplay
                              : applyButtonText}
                          </Button>
                          </div>
                        </Col>
                      </Row>
                    </div>
                    </>
                )}
                {PopulateOffersInCheckoutFlow()}
                {
              (showMsfFlag)?
                <div className="col-md-12 col-xs-12 text-center  m-t-20" style={{marginBottom: '32px'}}>                    
                 <text style={{color: 'rgba(51, 51, 51, 1)'}}>Pay with your Fortiva® Retail Credit credit card</text><br/>
                 <b><a href="#" className="syfClickEvent" data-object="link" data-reason="Use Fortiva Retail Card" data-type="Generic" onClick={showMsfUI} style={{color:'#143D59', fontSize:'16px', fontFamily:'Open Sans', textDecoration: 'none'}}>Use Fortiva Retail Card</a></b>
                </div>
                :<></>
            }
              </>
            )}
            {flowType !== "CHECKOUT" &&
              d2dFlow !== "Y" &&
              !isMerchantApiFailed &&
              offersDisplay && (
                <Container className={mppFromEmail ? "email-offer-msg" : "ml-0 p-0 onlyMediaScreen"} fluid={true}>
                  <p className="offer-msg">{!isSetPayIn4Alone && offerDisclaimer}</p>
                </Container>
              )}
          </div>
          {!(
            (revolvingOffer.offerType == "PPPP" &&
              revolvingOffer.discountEligible == "false") ||
            revolvingOffer.offerType == "SetPAYIn4" ||
            revolvingOffer.offerType == "SetPAY"
          ) &&
            !isMerchantApiFailed &&
            offersDisplay && (
              <Row className={mppFromEmail ? "emailButtonDisclouserRow" : "m-0"}>
                <div className={mppFromEmail ? "emailBottomDisclouser" : "bottomDisclouser"}>
                  {subtitleNoteSoftapplympp &&
                    <>
                      <div className="expansionInsideDiv">
                        {subtitleNoteSoftapplympp}
                      </div>
                      <hr className="divider" />
                    </>
                  }
                  <div className="expansionInsideDiv">
                    <b>
                      {parse(revolvingOffer.offerType === "WPDI"
                        ? (() => {
                            const title = revolvingOffer.offerBannerTitle || "";
                            const index = title.indexOf("<br/> Total Payments:");
                            return index > -1 ? title.substring(0, index).trim() : title;
                          })()
                        : revolvingOffer.offerBannerTitle)}
                    </b>
                  </div>
                  <div className="expansionInsideDiv">
                    {revolvingOffer.offerType == "WPDI" ? (
                      <b>{revolvingOffer.offerBannerSubTitle}</b>
                    ) : (
                      parse(revolvingOffer.offerBannerSubTitle)
                    )}
                  </div>
                  <div className="expansionInsideDiv">
                    <b>{parse(revolvingOffer.ofpTitle)}</b>
                  </div>
                  {revolvingOffer.limitedTimeOfferDateFormat && (
                    <div className="expansionInsideDiv">
                      {<b>{revolvingOffer.limitedTimeOfferDateFormat}</b>}
                    </div>
                  )}
                  <div className="expansionInsideDiv">
                    {parse(
                      revolvingOffer.monthlyPaymentDisclosure != ""
                        ? "<br/>" + revolvingOffer.monthlyPaymentDisclosure
                        : revolvingOffer.monthlyPaymentDisclosure
                    )}
                  </div>
                  <div className="expansionInsideDiv">
                    {parse(
                      revolvingOffer.offerDisclosure != undefined &&
                        revolvingOffer.discountEligible == "false" &&
                        revolvingOffer.offerDisclosure != ""
                        ? "<br/>" + revolvingOffer.offerDisclosure
                        : revolvingOffer.offerDisclosure
                    )}
                  </div>
                  <div className="expansionInsideDiv">
                    {parse(
                      revolvingOffer.offerDisclosureLanguage != ""
                        ? "<br/>" + revolvingOffer.offerDisclosureLanguage
                        : revolvingOffer.offerDisclosureLanguage
                    )}
                  </div>
                  {
                    quickScreenApproved && quickScreenInfo &&
                    <>
                      <div className="expansionInsideDiv quickScreenDisclosure">
                        {parse(quickScreenInfo.quickScreenNotification)}
                      </div>
                      <div className="expansionInsideDiv quickScreenDisclosure">
                        {parse(quickScreenInfo.qsCreditReportNotification)}
                      </div>
                      <div className="expansionInsideDiv">
                        <br />
                        {parse(quickScreenInfo.qsAccountTerms)}
                      </div>
                    </>
                  }
                </div>
              </Row>
            )}
        </div>
        {
          quickScreenApproved && (
            <div className="quickScreenFooter">
              <div className="preApprovalTextContainer">
                <img src={creditCardImage} alt="" />
                <p><b>{parse(quickScreenInfo.quickscrenOfferLanguage)}</b></p>
              </div>
              <div className="preApprovalLinks">
                <Button
                 className="syfClickEvent"
                 data-object ="button"
                 data-type = "body"
                 data-reason = "accept offer"
                  style={{
                    backgroundColor: mppPrimaryColors,
                    borderColor: mppPrimaryColors,
                  }}
                  onClick={openQsContinueHandler}
                >
                  <b>{applyButtonquickScreen}</b>
                </Button>
                <Button
                 className="syfClickEvent"
                 data-object ="button"
                 data-type = "body"
                 data-reason = "ask me later"
                  style={{
                    borderColor: mppPrimaryColors,
                    color: mppPrimaryColors,
                    backgroundColor: "white",
                    border:`2px sold ${mppPrimaryColors}`
                  }}
                  onClick={qsSaveUserActivity}
                >
                  <b>{declineButtonquickScreen}</b>
                </Button>
              </div>
              <a className="syfClickEvent startNewApplicationTxt"
                 data-object ="link"
                 data-type = "body"
                 data-reason = "start new application"
                style={{
                  color: mppPrimaryColors
                }}
                href="#"
                onClick={qsStartNewApplication}
              > <b>{startNewApplicationLinkquickScreen}</b>
              </a>
            </div>
          )
        }
      </>
      <Spinner isDisplayed={isSpinnerDisplayed}></Spinner>
    </React.Fragment>
  );
};
export default MppModalBody;
